import * as React from 'react';
import { Button, Panel } from 'react-bootstrap';
import FaIcon from '../../components/site/FaIcon';
import { inject } from '../../utils/decorators';
import { AuftragStore } from '../../stores/AuftragStore';

export enum MailVorlageArt {
  Auftragsbestätigung
}

interface IMailVorlageProps {
  caption: string;
  text: string;
  vorlage: MailVorlageArt;
}

export default class MailVorlage extends React.Component<IMailVorlageProps, {}> {

  @inject(AuftragStore) auftragStore: AuftragStore;

  erzeugeMailVorlage() {
    var titel = '';
    var inhalt = '';
    if (this.auftragStore.auftrag) {
      if (this.props.vorlage === MailVorlageArt.Auftragsbestätigung) {
        const auftrag = this.auftragStore.auftrag;
        titel = `DIQ Zert GmbH: Auftragsbestätigung zum Auftrag ${auftrag.auftrag_name}`;
        if (auftrag.refnrkunde) {
          titel += ` - Bestellung ${auftrag.refnrkunde} vom ${auftrag.refdatumkunde}`;
        }
        titel = encodeURIComponent(titel);
        inhalt = `Sehr geehrte Damen und Herren,%0D%0A %0D%0A`;
        if (auftrag.refnrkunde) {
          inhalt += `als Anlage erhalten Sie die Auftragsbestätigung zur Bestellung ${auftrag.refnrkunde} vom ${auftrag.refdatumkunde}.%0D%0A`;
        } else {
          inhalt += `als Anlage erhalten Sie die Auftragsbestätigung%0D%0A`;
        }
        inhalt += `Die erhaltenen Messmittel werden in unserem System im Auftrag mit der Referenznummer ${auftrag.refnr} bearbeitet.%0D%0A %0D%0A`;
      }
      if (titel !== '') {
        inhalt += `Für eventuelle Rückfragen stehen wir sehr gerne zur Verfügung.%0D%0A %0D%0AMit freundlichen Grüßen%0D%0ATeam der DIQ Zert GmbH`;
        var vorlage = `mailto:?subject=${titel}&body=${inhalt}`;
        window.location.href = vorlage;
      }
    }
  }

  render() {
    return (
      <Panel
        header={this.props.caption}
        bsStyle="success"
        footer={(
          <div className="text-right">
            <Button bsStyle="primary" onClick={() => this.erzeugeMailVorlage()}><FaIcon icon="envelope-o" /> Mailvorlage</Button>
          </div>
        )}
      >
        {this.props.text}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/MailVorlage.tsx